import baseApi from '@/dss-common/api/base';

export default baseApi.checklogin(true, false).then(
  res => {
    return res;
  },
  res => {
    throw res;
  }
);
